<template>
    <div id="contendor-principal-anexosDeConstitucion">
        <div id="contenedor-encabezados-salidasDelDia" class="container-fluid">
            <h1>Anexos para cédulas constituidas en domicilio</h1>
            <div id="encabezado-contenedor-contenido" class="form-inline mt-3">
                <div class="flex-grow-1 pl-3"><h4>Constitución cédulas de salida</h4></div>
            </div>
            <div class="area">
                <div id="seccion-constituciones" class="row">
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 pl-3 pt-4">
                    <div class="">
                        <h4>Filtros de búsqueda</h4>
                        <!-- <hr style="height:2px;border:none;color:#FFF;background-color:#FFF;"/> -->
                        <div class="row">
                            <div class="form-group col-xs-4 col-sm-4 col-md-4 col-lg-4 pr-3 align-self-end">
                                <C020Notificadores id="CNotificadores-VCD"
                                    class="p-0 m-0" 
                                    v-on:valorParaElPadre="cambioTipoNotificador" 
                                    :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                                    :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                                    :idDelInput="parametros_Notificadores.id" 
                                    :parametros="parametros_Notificadores.parametros" 
                                    :valorDefinido="parametros_Notificadores.valorDefinido" 
                                    :key="parametros_Notificadores.key + parametros_Notificadores.contRender"
                                    :filtrarPorJurisdiccion="true"></C020Notificadores>
                            </div>
                            <div class="form-group col-xs-6 col-sm-6 col-md-6 col-lg-6 pr-3">
                                <div id="filtro-fechas" class="form-inline">
                                    <h6 class="mr-2">Fecha de búsqueda: </h6>
                                    <input id="fecha-salida-gr" v-model="fechaBusqueda" type="date" class="form-control mr-2" />
                                   <!--  <button type="button" id="btn-limpiar-filtro" @click="evtResetearFiltrosBusqueda" class="btn-sm btn-primary"><i class="fas fa-undo"></i></button> -->
                                </div>
                                <!-- <div id="filtro-fechas" class="form-inline">
                                    <h6 class="mr-2">Fecha de busqueda: </h6>
                                    <input id="fecha-salida-gr" v-model="fechaBusqueda" type="date" class="form-control mr-2" />
                                    <button type="button" id="btn-limpiar-filtro" @click="evtResetearFiltrosBusqueda" class="btn-sm btn-primary"><i class="fas fa-undo"></i></button>
                                </div> -->
                            </div>
                            <div class="form-group col-xs-2 col-sm-2 col-md-2 col-lg-2 pl-0 pr-3 align-self-end">
                                <div class="form-inline justify-content-end">
                                    <button type="button" @click="evtBusquedaConstituciones" class="btn btn-primary"><i class="fas fa-search"></i>&nbsp;&nbsp;Buscar</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-show="!tablaConstituciones.cargandoCedulas" id="seccion-acciones" class="col-xs-12 col-sm-12 col-md-12 col-lg-12 pl-3 pt-3">
                    <div id="titulo-tabla-busqueda">
                        <div class="form-inline justify-content-start">
                            <i class="fas fa-clipboard-list mr-sm-2 texto-ajustable"></i>
                            <div class="align-content-center">
                                <h5 class="texto-ajustable">Listado de cédulas encontradas</h5>
                            </div>
                        </div>
                    </div>
                    <div class="">
                        <div class="form-inline justify-content-end">
                            <div id="inputs-filtro-memoria" class="form-inline pr-0">
                                <h6 for="f-busqueda" class="mr-sm-2">Buscar:</h6>
                                <input v-model="tablaConstituciones.filtroBusqueda" type="text" id="f-busqueda" placeholder="Buscar en todas las columnas" class="form-control flex-grow-1"/>
                            </div>
                        </div>
                        <CTablaGenericaCedulas class="table-responsive mt-4"
                            :idDelInput="tablaConstituciones.ID_TABLA"
                            :encabezadosColumnas="tablaConstituciones.ENCABEZADOS_COLUMNAS"
                            :accionesEnTabla="tablaConstituciones.ACCIONES"
                            :conResponsive="true"
                            :listaDeCedulas="tablaConstituciones.cedulasFiltroMemoria"
                            v-on:accionFuncionConstitucion="evtConstituirCedula"
                            :ref="tablaConstituciones.REF_TABLA"></CTablaGenericaCedulas>
                    </div>
                </div>
                <div v-show="tablaConstituciones.cargandoCedulas" class="col-xs-12 col-sm-12 col-md-12 col-lg-12 pl-3 pt-3">
                    <div class="contenedor-cargando" style="height: 300px ;">
                        <div class="text-center">
                            <i class="fas fa-spinner fa-spin fa-5x"></i>
                            <h4 class="mt-4">Cargando Cedulas</h4>
                        </div>
                    </div>
                </div>
            </div>
            </div>
        </div>
        <!-- MODAL PARA FORMULARIO ANEXOS DE CONSTITUCION -->
        <div class="modal align-middle" tabindex="-1" data-backdrop="static" data-keyboard="false"  id="formulario-anexo-constitucion">
            <div class="modal-dialog modal-lg modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Formulario de constitución</h5>
                        <button id="btn-cerrar-formulario-anexo-constitucion" @click="evtCerrarFormularioConstitucion" class="close" data-dismiss="modal"><i class="fas fa-times-circle"></i></button>
                    </div>
                    <div id="modal-formulario" class="modal-body" style="padding: 2em 3em 2em 3em">
                        <div id="contenedor-error-formulario" v-if="mostrarErroresFormAnexos && !this.archivoDeAnexoEsValido()">
                            <h6><i class="fas fa-exclamation-triangle text-danger"></i>&nbsp;Error en Formulario</h6>
                            <span style="text-align: justify; display:block;">Para poder agregar un anexo debes seleccionar un archivo(.JPEG, .JPG, .PNG, .PDF)</span>
                        </div>
                        <div class="form-group">
                            <h6 for="obs_constitucion">Observaciones (opcional)</h6>
                            <textarea id="obs_constitucion" v-model="observacionesConstitucion" rows="4" type="text" class="form-control"/>
                           <!--  <hr/> -->
                            <h6 for="seccion-archivo-anexo" style="padding:1.5em 0 0 0;">Anexo (opcional)&nbsp;
                                <i v-if="mostrarErroresFormAnexos && this.archivoDeAnexoEsValido()" class="fas fa-check-circle text-success font-size: 15px;"></i>
                                <i v-if="mostrarErroresFormAnexos && !this.archivoDeAnexoEsValido()" class="fas fa-times-circle text-danger font-size: 25px;"></i></h6>
                            <div class="form-inline justify-content-between" id="seccion-archivo-anexo">
                                <input type="file" id="input-anexo-archivo-salidas-notificador" :class="[mostrarErroresFormAnexos && !this.archivoDeAnexoEsValido() ? 'form-control border border-danger col-7' : 'form-control col-7']" v-on:change="evtAgregarAnexo($event)" accept=".JPEG,.JPG,.PNG,.PDF" />
                                <button v-if="!cancelarAgregarAnexo" type="button" @click="evtAgregarAnexoEnLista" class="btn-sm btn-primary"><i class="fas fa-plus-circle"></i>&nbsp;&nbsp;Agregar</button>
                                <button v-if="cancelarAgregarAnexo" type="button" @click="cancelarAgregarAnexo = false, mostrarErroresFormAnexos = false" class="btn-sm btn-primary"><i class="fas fa-times-circle"></i>&nbsp;&nbsp;Cancelar</button>
                            </div>
                            <div v-show="anexosTabla.length > 0" id="tabla-anexos" class="mt-3">
                                <CTablaGenericaCedulas class="table-responsive"
                                    :ref="REF_TABLA_ANEXOS"
                                    :idDelInput="ID_TABLA_ANEXOS"
                                    :conResponsive="true"
                                    :encabezadosColumnas="encabezadosColumnasTA"
                                    :accionesEnTabla="ACCIONES_TANEXOS"
                                    :listaDeCedulas="anexosTabla"
                                    v-on:accionFuncionEliminar="evtRemoverAnexo($event)"></CTablaGenericaCedulas>
                            </div>
                        </div>
                        <div v-if="anexosDeConstitucion.length > 0" class="d-flex justify-content-end mt-1"><button type="button" @click="evtGuardarConstitucion" class="btn-sm btn-primary"><i class="fas fa-save"></i>&nbsp;&nbsp;Guardar</button></div>
                    </div>             
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import enumeraciones from '@/../static/js/enumeraciones'
import sistemas from '@/../static/js/sistemas'
import comun from "@/../static/js/comun"
import api from '@/../static/js/api'
import axios from 'axios'
import moment from 'moment'
import catalogos from '@/../static/js/catalogos'

export default {
    components: {
         CTablaGenericaCedulas: sistemas.SINOJ.CTablaGenericaCedulas,
         C020Notificadores: catalogos.SINOJ.C020Notificadores
    },
    data() {
        return {
            enumeraciones,
            ID_TABLA_ANEXOS: 'TanexosConstitucionForm',
            REF_TABLA_ANEXOS: 'TanexosConstitucionForm',
            encabezadosColumnasTA: ['#','Anexo',''],
            ACCIONES_TANEXOS: {motrarAcciones: true,check: false, eliminar: true},
            notificadorId: -1,
            fechaBusqueda: moment().format('YYYY-MM-DD'),
            observacionesConstitucion: null,
            anexosDeConstitucion: [],
            anexosTabla: [],
            archivoAnexoSeleccionado: null,
            contadorAnexos: 0,
            mostrarErroresFormAnexos: false,
            cancelarAgregarAnexo: false,
            cedulaSeleccionada: null,
            FORMATO_FECHA: "DD/MM/YYYY HH:mm:ss",
            constituciones: {
                cedulas: [],
                fechaBusqueda: moment().format('YYYY-MM-DD')
            },
            tablaConstituciones: {
                cedulasDB: [],
                cedulas: [],
                cedulasFiltroMemoria: [],
                filtroBusqueda: null,
                ID_TABLA: 'TanexosConstitucionSN',
                REF_TABLA: 'TanexosConstitucionSN',
                ENCABEZADOS_COLUMNAS: ['Folio','Consecutivo','Urgente','Domicilio','Persona a notificar','Tipo de cédula','Estatus',''],
                ACCIONES: { motrarAcciones: true,check: false, eliminar: false, constituir: true },
                cargandoCedulas: false
            },
            parametros_Notificadores: {
                id: 'ID-CTipoNotificadorVADC',
                parametros: {NotififadorId: null, ZonaId: null, ConInactivos: false, ConZona: false, ConCedulas: false, ConSalidas:false, ConAsignacionDeFraccionamientos: false},
                valorDefinido: -1,
                key: 'CTipoNotificadorVADC',
                contRender: 0
            },
            esNotificador: false
        }
    },
    methods: {
        evtConstituirCedula: function(evento) {
            this.cedulaSeleccionada = this.obtenerCedulaSeleccionado(evento);
            //console.log('cedSel::',this.cedulaSeleccionada);
            $('#formulario-anexo-constitucion').modal('show');
            this.$nextTick(() => {
                this.$refs[this.REF_TABLA_ANEXOS].cedulasAmostrarPorPagina = 1;
            });
        },
        obtenerCedulaSeleccionado: function(evento) {
            let salida = null;
            const CEDULA_SELECCIONADA = evento.target.getAttribute('id');
            const ID_CEDULA = parseInt(this.obtenerCedula(CEDULA_SELECCIONADA));
            this.tablaConstituciones.cedulasDB.filter(sDB => sDB.Cedula.CedulaId == ID_CEDULA).forEach(s => {
                salida = s;
            });
            return salida;
        },
        obtenerCedula: function(cedulaSeleccionada) {
            const CEDULA = cedulaSeleccionada.split('-');
            const POSICION_ID = (CEDULA.length - 1);
            const ID_CEDULA = CEDULA[POSICION_ID];
            return ID_CEDULA;
        },
        evtBusquedaConstituciones: function() {
            let peticionAPI = { 
                NotificadorId: this.campoRequeridoEsValido(this.notificadorId) ? this.notificadorId : null, 
                FechaInicial: this.campoRequeridoEsValido(this.fechaBusqueda) ? this.fechaBusqueda : null, 
                esPrueba: false }
            if(this.fechaBusqueda <= moment().format('YYYY-MM-DD')) 
                this.obtenerConstitucionesDeNotificadorBD(peticionAPI);
            else
                comun.mensajeDeAlerta('Se detectaron campos incorrectos,<br>Debes ingresar una fecha de búsqueda menor o igual a la fecha del dia de hoy.');
        },
        evtResetearFiltrosBusqueda: function() {
            if(!this.esNotificador) {
                this.parametros_Notificadores.valorDefinido = -1;
                this.notificadorId = this.parametros_Notificadores.valorDefinido;
                this.parametros_Notificadores.contRender ++;
            }
            this.fechaBusqueda = moment().format('YYYY-MM-DD');
        },
        cambioTipoNotificador: function(evento) {
            this.notificadorId = parseInt(evento.target.value);
        },
        filtrarCedulasTabla: function(e) {
            this.tablaConstituciones.cedulasFiltroMemoria = this.tablaConstituciones.cedulas
            .filter(c => {
                return Object.values(c).some(valorColumna => this.predicateFiltradoPorSimilitud(valorColumna, this.tablaConstituciones.filtroBusqueda));
            });
            console.log()
        },
        predicateFiltradoPorSimilitud: function(elementoAEvaluar,compararCon) { 
            if(this.campoRequeridoEsValido(compararCon)) {
                if(elementoAEvaluar.toString().toUpperCase().startsWith(compararCon.toString().toUpperCase()))
                    return true;
                else
                    return false;
            }
            else
                return true;
        },
        evtCerrarFormularioConstitucion: function() {
            this.limpiarFormularioConstitucion();
        },
        limpiarFormularioConstitucion: function() {
            this.observacionesConstitucion = null;
            this.archivoAnexoSeleccionado = null;
            this.mostrarErroresFormAnexos = false;
            this.anexosTabla = [];
            this.anexosDeConstitucion = [];
            $("#input-anexo-archivo-salidas-notificador").val('');
            this.contadorAnexos = 0;
            this.cancelarAgregarAnexo = false;
            this.cedulaSeleccionada = null;
        },
        archivoDeAnexoEsValido: function() {
            let esValido = false;
            if(this.archivoAnexoSeleccionado != null)
                esValido = true;
            return esValido
        },
        evtAgregarAnexo: function(evento) {
            try {
                if(evento.target.files.length > 0) {
                    this.archivoAnexoSeleccionado = evento.target.files[0];
                    this.cancelarAgregarAnexo = false;
                }
                else {
                    this.archivoAnexoSeleccionado = null;
                }
            }
            catch(error) {
                comun.mensajeDeAlerta(error);
            }
        },
        evtAgregarAnexoEnLista: function() {
            if(this.archivoDeAnexoEsValido()) {
                let anexoObjTabla = {};
                anexoObjTabla.Folio = this.contadorAnexos += 1;
                anexoObjTabla.Anexo = this.archivoAnexoSeleccionado.name;
                this.anexosTabla.push(anexoObjTabla);
                let archivoAnexo = {};
                archivoAnexo.Referencia = anexoObjTabla.Folio;
                archivoAnexo.Archivo = this.archivoAnexoSeleccionado;
                this.anexosDeConstitucion.push(archivoAnexo);
                if(this.anexosTabla.length > 0 && this.anexosDeConstitucion.length > 0) {
                    $("#input-anexo-archivo-salidas-notificador").val('');
                    this.archivoAnexoSeleccionado = null;
                    this.mostrarErroresFormAnexos = false;
                }
            }
            else {
                this.cancelarAgregarAnexo = true;
                this.mostrarErroresFormAnexos = true;
            }
        },
        evtRemoverAnexo: function(evento) {
            const ANEXO_SELECCIONADO = evento.target.getAttribute('id');
            const ID_ANEXO_COMPLETO = ANEXO_SELECCIONADO.split('-');
            const ID_ANEXO = ID_ANEXO_COMPLETO[ID_ANEXO_COMPLETO.length -1];
            this.anexosTabla = this.anexosTabla.filter(a => a.Folio != ID_ANEXO);
            this.anexosDeConstitucion = this.anexosDeConstitucion.filter(ad => ad.Referencia != ID_ANEXO);
            if(this.anexosTabla.length < 1 && this.anexosDeConstitucion.length < 1)
                this.contadorAnexos = 0; 
        },
        evtGuardarConstitucion: async function() {
            let peticionAPI = await Promise.resolve(this.crearPeticionDeConstitucion());
            console.log('peticion::',peticionAPI);
            this.guardarConstitucionDeCedulaBD(peticionAPI);
        },
        crearPeticionDeConstitucion: async function() {
            let peticion = new FormData();
            let salidaObj = {};
            salidaObj.SalidaId = this.cedulaSeleccionada.SalidaId;
            salidaObj.FechaSalida = this.cedulaSeleccionada.FechaSalida;
            salidaObj.Notificador = null;
            salidaObj.Cedula = {
                CedulaId: this.cedulaSeleccionada.Cedula.CedulaId
            };
            let constitucionObj = {};
            constitucionObj.ConstitucionId = this.cedulaSeleccionada.Constituciones[0].ConstitucionId;
            constitucionObj.FechaConstitucion = this.cedulaSeleccionada.Constituciones[0].FechaConstitucion;
            constitucionObj.Observaciones = this.campoRequeridoEsValido(this.observacionesConstitucion) ? this.observacionesConstitucion : null;
            constitucionObj.Salida = null;
            let anexosObj = [];
            this.anexosDeConstitucion.forEach(a => {
                peticion.append(a.Referencia,a.Archivo);
                let anexoObj = {};
                anexoObj.AnexosConstitucionId = -1;
                anexoObj.AnexoRuta = a.Referencia;
                anexoObj.Constitucion = null;
                anexosObj.push(anexoObj);
            });
            constitucionObj.Anexos = anexosObj;
            salidaObj.Constituciones = [constitucionObj];
            peticion.append('Salida',JSON.stringify(salidaObj));
            peticion.append('EsPrueba',false);
            /* console.log('VALORES FORMDATA');
            for (var pair of peticion.entries()) {
                console.log(pair[0]+ ', ',pair[1]); 
            } */
            return peticion;
        },
        guardarConstitucionDeCedulaBD: function(peticionAPI) {
           const SERVIDOR = api.conexion;
           const METODO_API_GUARDAR = api.SINOJ.sistema.notificaciones.salidasDelDia.GuardarAnexosDeConstitucion;
           let urlApi = SERVIDOR + METODO_API_GUARDAR;
            let peticionArchivos = false;
            let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, peticionArchivos,false);
            $('#formulario-anexo-constitucion').modal('hide');
            comun.SeEstaCargandoInformacion(true);
            axios.post(urlApi, peticionAPI, headerPeticion)
                    .then(respuesta => {            
                        if (respuesta.data.SiHayError) {
                            let mensajeError = respuesta.data.Error.Mensaje;
                            console.log(mensajeError);
                            comun.mensajeDeAlerta(mensajeError, null, null);
                             $('#formulario-anexo-constitucion').modal('show');
                        } 
                        else {
                           // comun.mensajeDeAlerta(respuesta.data.Satisfactorio);
                            this.limpiarFormularioConstitucion();
                            this.evtBusquedaConstituciones();
                            comun.mensajeDeAlerta(respuesta.data.Satisfactorio, null, null);
                        }
                    })
                    .catch(excepcion => {
                        comun.SeEstaCargandoInformacion(false);
                        console.log(excepcion);
                        comun.mensajeDeAlerta(enumeraciones.error.E500, null, null);
                    }
            ); 
        },
        obtenerConstitucionesDeNotificadorBD: function(peticionAPI) {
            const SERVIDOR = api.conexion;
            const METODO_API_OBTENER = api.SINOJ.sistema.notificaciones.salidasDelDia.ObtenerConstitucionesSalidaDeNotificador;
            let urlApi = SERVIDOR + METODO_API_OBTENER;
            let peticionArchivos = false;
            let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, peticionArchivos,false);
            comun.SeEstaCargandoInformacion(true);
            this.tablaConstituciones.cargandoCedulas = true;
            axios.post(urlApi, peticionAPI, headerPeticion)
                    .then(respuesta => {            
                        if (respuesta.data.SiHayError) {
                            let mensajeError = respuesta.data.Error.Mensaje;
                            console.log(mensajeError);
                            comun.mensajeDeAlerta(mensajeError, null, null);
                        } 
                        else {
                            this.tablaConstituciones.cedulasDB = (respuesta.data.Salidas != null) ? respuesta.data.Salidas : [];
                            this.tablaConstituciones.cedulas = this.darFormatoCedulasTabla(this.tablaConstituciones.cedulasDB);
                            this.tablaConstituciones.cedulasFiltroMemoria = this.tablaConstituciones.cedulas;
                            this.$nextTick(() => {
                                $("#inputs-filtro-memoria input").on("change paste keyup", (e) => {
                                    if(this.tablaConstituciones.cedulas.length > 0) {
                                        this.filtrarCedulasTabla(e);
                                    }
                                });
                            });
                        }
                        this.tablaConstituciones.cargandoCedulas = false;
                        comun.SeEstaCargandoInformacion(false);
                    })
                    .catch(excepcion => {
                        this.tablaConstituciones.cargandoCedulas = false;
                        comun.SeEstaCargandoInformacion(false);
                        console.log(excepcion);
                        comun.mensajeDeAlerta(enumeraciones.error.E500, null, null);
                    }
            ); 
        },
        darFormatoCedulasTabla: function(cedulas) {
            let cedulasConFormato = [];
            cedulasConFormato = cedulas.map(s => {
                let cedula = this.cedulaAObjetoTabla(s);
                return cedula;
            });
            return cedulasConFormato;
        },
        cedulaAObjetoTabla: function(salida) {
            // 'Folio','Consecutivo','Urgente','Domicilio','Persona a notificar','Tipo de cédula','Fecha de asignación'
            let cedulaObjTabla = {};
            cedulaObjTabla.Folio = salida.Cedula.CedulaId;
            cedulaObjTabla.Consecutivo = 'Sin consecutivo';
            if(this.campoRequeridoEsValido(salida.Cedula.Expediente)) { 
                cedulaObjTabla.Consecutivo = salida.Cedula.Expediente.NumeroDeDocumento;
            }
            cedulaObjTabla.urgente = (salida.Cedula.Urgente) ? 'SI' : 'NO';
            cedulaObjTabla.Domicilio = 'Sin Domicilio';
            cedulaObjTabla.PersonaANotificar = 'Sin Persona a Notificar';
            if(this.campoRequeridoEsValido(salida.Cedula.PersonasANotificar)) {
                if(salida.Cedula.PersonasANotificar[0].Domicilios != null && salida.Cedula.PersonasANotificar[0].Domicilios.length > 0) {
                    const DOMICILIO_OBJ = salida.Cedula.PersonasANotificar[0].Domicilios[0];
                    let infAdicionalNumExt = (this.campoRequeridoEsValido(DOMICILIO_OBJ.InformacionAdicionalDeNumeroExterior)) ? ` ${ DOMICILIO_OBJ.InformacionAdicionalDeNumeroExterior }` : '';
                    let numInterior = (this.campoRequeridoEsValido(DOMICILIO_OBJ.NumeroInterior)) ? `int ${ DOMICILIO_OBJ.NumeroInterior.toString().trim() }` : '';
                    if(this.campoRequeridoEsValido(DOMICILIO_OBJ.Fraccionamiento)) {
                        cedulaObjTabla.Domicilio = `${ DOMICILIO_OBJ.Calle } #${ DOMICILIO_OBJ.NumeroExterior }${ infAdicionalNumExt } ${ numInterior }, ${ DOMICILIO_OBJ.Fraccionamiento.Nombre }, ${ DOMICILIO_OBJ.Fraccionamiento.Municipio.Nombre }`;
                    }
                    else {
                        /* 
                            para los casos de domicilios con fraccionamiento que no pertenece al catalogo de fraccionamientos, se guarda la informacion el un solo campo (008FraccionamientoFueraDeCatalogo => FraccionamientoFueraDeCatalogo)
                            con el siguiente formato NOMBRE_FRACCIONAMIENTO, NOMBRE_MUNICIPIO, si se modifica posteriormenete este formato se tendra que reemplazar esta 
                            logica.
                            */
                        let fraccionamientoCompuesto = DOMICILIO_OBJ.FraccionamientoFueraDeCatalogo.split(',');
                        let nombreFraccionamiento = fraccionamientoCompuesto[0];
                        let nombreMunicipio = fraccionamientoCompuesto[1];
                        cedulaObjTabla.Domicilio = `${ DOMICILIO_OBJ.Calle } #${ DOMICILIO_OBJ.NumeroExterior }${ infAdicionalNumExt } ${ numInterior }, ${ nombreFraccionamiento }, ${ nombreMunicipio }`;
                    }

                    /* const DOMICILIO_OBJ = salida.Cedula.PersonaANotificar.Domicilios[0];
                    let infAdicionalNumExt = (this.campoRequeridoEsValido(DOMICILIO_OBJ.InformacionAdicionalDeNumeroExterior)) ? ` ${ DOMICILIO_OBJ.InformacionAdicionalDeNumeroExterior }` : '';
                    let numInterior = (this.campoRequeridoEsValido(DOMICILIO_OBJ.NumeroInterior)) ? `int ${ DOMICILIO_OBJ.NumeroInterior }` : '';
                    cedulaObjTabla.Domicilio = `${ DOMICILIO_OBJ.Calle } #${ DOMICILIO_OBJ.NumeroExterior }${ infAdicionalNumExt } ${ numInterior }, ${ DOMICILIO_OBJ.Fraccionamiento.Nombre }, ${ DOMICILIO_OBJ.Fraccionamiento.Municipio.Nombre }`; */
                }
                
                if(this.campoRequeridoEsValido(salida.Cedula.PersonasANotificar[0].DatosGenerales)) {
                    const { Fisica, Moral } = salida.Cedula.PersonasANotificar[0].DatosGenerales;
                    if(this.campoRequeridoEsValido(Fisica))
                        cedulaObjTabla.PersonaANotificar = `${ Fisica.Nombre.toUpperCase().trim() } ${ Fisica.ApellidoPaterno.toUpperCase().trim() }${ (this.campoRequeridoEsValido(Fisica.ApellidoMaterno)) ? (" " + Fisica.ApellidoMaterno.toUpperCase().trim()) : "" }`; 
                    else if(this.campoRequeridoEsValido(Moral))
                        cedulaObjTabla.PersonaANotificar = `${ Moral.Nombre.trim() }`; 
                }
            }
            cedulaObjTabla.TipoCedula = (this.campoRequeridoEsValido(salida.Cedula.TipoCedula.Nombre)) ? salida.Cedula.TipoCedula.Nombre.trim() : 'Sin tipo de cedula';
            /* cedulaObjTabla.fechaAsignacion = this.campoRequeridoEsValido(salida.Cedula.AsignacionesDeNotificador[0].FechaDeAsignacion) ? moment(salida.Cedula.AsignacionesDeNotificador[0].FechaDeAsignacion).format(this.FORMATO_FECHA) : 'Sin fecha de asignacion'; */
            cedulaObjTabla.Estatus = salida.Cedula.Estatus.Nombre;
            //cedulaObjTabla.Estatussssssss = salida.Cedula.Estatus.Nombre;
            return cedulaObjTabla;
        },
        campoRequeridoEsValido: function(campo) { 
          let esValido = false
          if(typeof campo === 'string' || campo instanceof String) {
              // valida que filtro tipo cadena no sea nula, indefinida y compuestas solo de espacios en blanco o saltos de linea
              if (campo != null && campo != undefined && campo != '' && campo.replace(/\s/g, '').length) {
                  esValido = true;
              }
          }
          else if (typeof campo === 'number' || campo instanceof Number) {
              // valida que filtro tipo numerico no sea nulo, indefinido y que tengan una valor definido valido (diferente a -1)
              if (campo != null && campo != undefined && campo > 0) {
                  esValido = true;
              }
          }
          else if (typeof campo === 'array' || campo instanceof Array) {
              // valida que filtro tipo numerico no sea nulo, indefinido y que tengan una valor definido valido (diferente a -1)
              if (campo != null && campo != undefined && campo.length > 0) {
                  esValido = true;
              }
          }
          else {
              if (campo != null && campo != undefined) {
                  esValido = true;
              }
          }
          return esValido;
      },
      asignarValoresUsuarioNotificador: async function() { 
          try {
            const SERVIDOR = api.conexion;
            const METODO_API_OBTENER = api.SINOJ.sistema.consultas.consultaDireccion.ObtenerDatosDeNotificador;
            let urlApi = SERVIDOR + METODO_API_OBTENER;
            let peticionAPI = { esPrueba: false };
            let peticionArchivos = false;
            let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, peticionArchivos,false);
            this.cargandoCedulas = true;
            const PETICION_NOTIFICADOR = await axios.post(urlApi, peticionAPI, headerPeticion);
            const DATOS_PETICION = await PETICION_NOTIFICADOR.data;
            let { SiHayError, Error, Notificador } = DATOS_PETICION;
            if (SiHayError) {
                let mensajeError = Error.Mensaje;
                console.log(mensajeError);
            } 
            else {
                this.parametros_Notificadores.valorDefinido = Notificador.NotificadorId;
                this.notificadorId = Notificador.NotififadorId;
                this.parametros_Notificadores.contRender ++;
                this.$nextTick(() => {
                    $('#CNotificadores-VCD').addClass('catalogoInformativo');
                });
                this.esNotificador = true;
                //console.log('Notificador::',Notificador);
            }
          }
          catch(excepcion) {
              console.log(excepcion);
              comun.mensajeDeAlerta(enumeraciones.error.E500, null, null);
          }
      },
    },
    async mounted() {
        await Promise.resolve(this.asignarValoresUsuarioNotificador());
    },
    created() {
        let peticionAPI = { NotificadorId: null, FechaInicial: this.fechaBusqueda, esPrueba: false }
        this.obtenerConstitucionesDeNotificadorBD(peticionAPI);
    },
}
</script>
<style scoped>
#inputs-filtro-memoria {
    width: 50vmin;
}

.catalogoInformativo {
    pointer-events:none;
    cursor: not-allowed;
    opacity: 0.5;
}

#formulario-anexo-constitucion .modal-lg {
    max-width: 50% !important;
}

#formulario-anexo-constitucion .modal-header {
    background-color: rgb(36, 34, 34);;
    border: none;
}

#encabezado-contenedor-contenido {
  background-color: rgb(41, 40, 40);
  padding: 10px;
}

#encabezado-contenedor-contenido .btn {
  background-color: black;
  padding-left: 15px;
  padding-right: 15px;
}

#contenedor-error-formulario {
    padding: 1em;
    background-color: #26272b;
    border: 1px solid #5c5959;
    border-radius: 8px;
    margin-bottom: 1em;;
}

.contenedor-color-negro {
    padding: 1.5em;
    background-color: #2c2d31;
    box-shadow: 0px 6px 20px 8px #161616;
}

#titulo-tabla-busqueda {
    
    padding-top: 13px;
    padding-bottom: 8px;
    margin-top: 1vw;
}

.contenedor-cargando {
    background-color: rgb(36, 34, 34);
    height: 40px;
    height: 21rem;
    display: flex;
    align-items: center;
    justify-content: center;
}

.texto-ajustable {
    font-size: 3.5vmin;
}

#filtro-fechas .btn-sm {
  cursor: pointer;
  background-color: rgb(27, 25, 25);
  padding: 5px 15px 5px 15px;
} 

#filtro-fechas .btn-sm:hover, #filtro-fechas .btn-sm:focus {
  background-color: black;
}

#modal-formulario .btn-sm {
    cursor: pointer;
    background-color: rgb(27, 25, 25);
}
</style>


// WEBPACK FOOTER //
// src/components/SINOJ/Notificaciones/Constituciones/CAnexosDeConstituciones.vue